import { Button } from "@itandi/itandi-bb-ui";
import type React from "react";
import { AddModal } from "~/components/specifics/settings/imports/[importType]/import_conversions/AddModal";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type { ImportType } from "~/models/ImportLog";
import Styles from "./ImportConversionTop.module.scss";

type Props = {
	importType: ImportType;
};

export const ImportConversionTop: React.FC<Props> = ({ importType }: Props) => {
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	return (
		<div className={Styles.ImportConversionTop}>
			<Button onClick={handleOpen} variant="secondary">
				取込変換設定を追加
			</Button>
			<AddModal
				handleClose={handleClose}
				importType={importType}
				isOpen={isOpen}
			/>
		</div>
	);
};
